import { gql } from "@apollo/client";

import { AiExerciseId, Category } from "./types";

export const addSessionMutation = gql`
    mutation AddSession($data: SessionCreateInput!) {
        addSession(data: $data) {
            id
            durationTotal
            durationEndurance
            durationStrength
            durationCoordination
            durationRelaxation
            durationMobility
            durationAi
            exercises {
                id
                nameDe
                nameEn
                category
            }
            aiExercises
        }
    }
`;

export interface AddSessionVariables {
    data: {
        userId: string;
        durationTotal: number;
        exercises: number[];
        aiExercises: AiExerciseId[];
        durationEndurance: number;
        durationStrength: number;
        durationRelaxation: number;
        durationMobility: number;
        durationCoordination: number;
        durationAi: number;
    };
}

export interface AddSessionType {
    id: string;
    durationTotal: number;
    durationEndurance: number;
    durationStrength: number;
    durationCoordination: number;
    durationRelaxation: number;
    durationMobility: number;
    durationAi: number;
    exercises: {
        id: number;
        nameDe: string;
        nameEn: string;
        category: Category;
    };
    aiExercises: AiExerciseId[];
}
